<template>
  <div class="wrapper">
    <div class="searchconditions">
      <el-form :model="listForm" ref="listForm" inline>
        <el-form-item label="物料名称">
          <el-autocomplete
            :popper-append-to-body="false"
            v-model="productName"
            :fetch-suggestions="querySearch"
            placeholder="请输入物料名称"
            @select="(item) => handleSelect(item)"
          >
            <template slot-scope="{ item }">
              <div class="name">{{ item.productName }}</div>
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="物料类型">
          <el-select v-model="listForm.data.productTypeId">
            <el-option label="全部" value=""> </el-option>
            <el-option
              v-for="(item, index) of productTypeList"
              :key="index"
              :label="item.productTypeName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="cyan" @click="searchList"
            >查询</el-button
          >
          <el-button icon="el-icon-refresh" type="warning" @click="reset"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="list" v-loading="loading" border>
      <el-table-column
        type="index"
        label="序号"
        width="80"
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="companyName"
        label="工厂名称"
        align="center"
        min-width="150"
      ></el-table-column> -->
      <el-table-column
        prop="productName"
        label="物料名称"
        align="center"
        min-width="150"
      ></el-table-column>
      <el-table-column
        prop="specifications"
        label="规格 "
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productTypeName"
        label="类型"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="productQuantity"
        label="库存总数量（吨）"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-view"
            @click="detailBtn(scope.row)"
            >详细信息</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next, total"
      :page-size="listForm.pageSize"
      :total="total"
      :current-page="listForm.pageNum"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    >
    </el-pagination>
    <el-dialog
      title="详细信息"
      :visible.sync="dialogInfo"
      :close-on-click-modal="false"
      @close="handleInfoClose"
    >
      <el-form
        :model="productInfo"
        ref="productInfo"
        label-width="120px"
        v-if="productInfo"
        class="dialog-Info"
      >
        <h3 style="margin-bottom: 20px; color: #4da4ca">
          {{ productInfo.companyName }}
        </h3>
        <el-row>
          <el-col :span="12">
            <el-form-item label="物料编码:">
              <span>{{ productInfo.productCode }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="物料名称：">
              <span>{{ productInfo.productName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="物料类型：">
              <span>{{ productInfo.productTypeName }}</span>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="品牌：" prop="">
              <span>{{ productInfo.productBrandName }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="规格：">
              <span>{{ productInfo.specifications }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="库存总数量：">
              <span>{{ productInfo.productQuantity }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="库存总重量：" prop="totalWeight">
              <span>{{ productInfo.totalWeight }} 吨</span>
            </el-form-item>
          </el-col>
        </el-row>
        <div
          v-for="(item, index) in productInfo.productionBatchList"
          :key="index"
          class="product-box"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="批次号：">
                <span>{{ item.productBatchNum }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="生产日期：">
                <span>{{ item.createDate | dateformat }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="数量：">
                <span>{{ item.productCount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="重量：">
                <span>{{ item.weight }} 吨</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="dialogInfo = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryStockPageList,
  exportStock,
  getProductTypeList,
  getFlowsCompanyInfos,
  getAllProductList,
} from "@/common/api.js";
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  data() {
    return {
      listForm: {
        pageNum: 1,
        pageSize: 10,
        data: {
          productId: "",
          productTypeId: "",
        },
      },
      productName: "",
      productList: [],
      productTypeList: [],
      list: [],
      loading: false,
      total: 0,
      dialogInfo: false,
      productInfo: {
        companyName: "",
        productCode: "",
        productName: "",
        productBrandName: "",
        productTypeName: "",
        specifications: "",
        productQuantity: "",
        productionBatchList: [],
      },
      normalizer(node) {
        console.log(node);
        if (
          node.productionChildList == null ||
          node.productionChildList.length == 0
        ) {
          delete node.productionChildList;
        }
        return {
          id: node.id,
          label: node.productTypeName,
          children: node.productionChildList,
        };
      },
    };
  },
  methods: {
    getPageList() {
      var params = this.listForm;
      this.loading = true;
      queryStockPageList(params).then((res) => {
        this.loading = false;
        if (res.errorCode == 200) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 产品类型列表
    getProductTypeList() {
      var params = {};
      getProductTypeList(params).then((res) => {
        if (res.errorCode == 200) {
          this.productTypeList = res.data;
        }
      });
    },
    // 物料列表
    getProdictList() {
      let params = {
        productName: "",
      };
      getAllProductList(params).then((res) => {
        this.productList = res.data;
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.productList;
      if (queryString == "" || queryString == undefined) {
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
        cb(results);
      } else {
        let params = {
          productName: queryString || "",
        };
        getAllProductList(params).then((res) => {
          cb(res.data);
        });
      }
      // 调用 callback 返回建议列表的数据
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.productName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      console.log(item);
      this.productName = item.productName;
      this.listForm.data.productId = item.productId;
    },
    //选择产品类型
    orgTreeSelected(node) {
      this.listForm.data.productTypeId = node.id;
    },
    detailBtn(row) {
      this.dialogInfo = true;
      this.$nextTick(() => {
        this.productInfo = {
          companyName: row.companyName,
          productCode: row.productCode,
          productName: row.productName,
          productBrandName: row.productBrandName,
          productTypeName: row.productTypeName,
          specifications: row.specifications,
          productQuantity: row.productQuantity,
          productionBatchList: row.productionBatchList,
        };
      });
    },

    handleCurrentChange(cpage) {
      this.listForm.pageNum = cpage;
      this.getPageList();
    },
    handleSizeChange(psize) {
      this.listForm.pageSize = psize;
      this.getPageList();
    },
    handleInfoClose() {
      this.productInfo = {
        companyName: "",
        productCode: "",
        productName: "",
        productBrandName: "",
        productTypeName: "",
        specifications: "",
        productQuantity: "",
        productionBatchList: [],
      };
    },
    exportStockXml() {
      var params = this.listForm;
      exportStock(params)
        .then((res) => {
          const blob = new Blob([res]);
          console.log(res);
          const fileName = "库存查询表.xls";
          const elink = document.createElement("a"); // 创建a标签
          elink.download = fileName; // 为a标签添加download属性
          // a.download = fileName; //命名下载名称
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click(); // 点击下载
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink); // 释放标签
          this.loadingExt = false;
          axios.defaults.responseType = "json";
        })
        .catch((res) => {
          axios.defaults.responseType = "json";
        });
    },
    //   查询
    searchList() {
      this.listForm.pageNum = 1;
      this.getPageList();
    },
    reset() {
      this.listForm = {
        pageNum: 1,
        pageSize: 10,
        data: {
          productId: "",
          productTypeId: "",
        },
      };
      this.productName = "";
      this.getPageList();
    },
  },
  mounted() {
    this.getPageList();
    this.getProdictList();
    this.getProductTypeList();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;

  .searchconditions {
    width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px 15px;
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
    .el-form {
      .el-form-item {
        display: inline-block;
        margin-right: 10px;
        vertical-align: top;
        margin: 5px 15px 5px 0px;
        /deep/.el-button {
          padding: 8px 15px;
          font-size: 12px;
          border-radius: 3px;
        }
      }
    }
  }
  /deep/.vue-treeselect__placeholder,
  .vue-treeselect__single-value {
    line-height: 40px;
  }
  /deep/.vue-treeselect__input {
    vertical-align: top;
  }
  .dialog-Info {
    /deep/.el-form-item {
      margin-bottom: 0;
    }
  }
  .el-row {
    // margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
  }
  .product-box {
    margin-top: 20px;
    box-shadow: #d0d0d0 0px 0px 10px;
    border-radius: 5px;
    padding: 10px 0;
  }
  /deep/ .el-autocomplete-suggestion {
    min-width: 100%;
    width: auto !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/inAndOutWarehouse/stockManage.vue